import { MeHealthCenter, Mode } from '../api/me'

export const MODE_COLORS: Record<string, string> = {
  attention: '#2196F3',
  contability: '#4CAF50',
  calendar: '#FF5722',
  admin: '',
}

export const MODE_NAMES: Record<string, string> = {
  attention: 'Pacientes',
  contability: 'Contabilidad',
  calendar: 'Agenda',
  admin: '',
}

const DEFAULT_COLOR = '#2196F3'

export function getModeColor(mode: Mode): string {
  const color = MODE_COLORS[mode]
  return color !== undefined && color !== '' ? color : DEFAULT_COLOR
}

export function resolveMode(healthCenter: MeHealthCenter, modeParam: string | null): Mode {
  const normalized = modeParam === 'atention' ? 'attention' : modeParam
  const isKnown = (candidate: string | null): candidate is Mode =>
    candidate === 'attention' || candidate === 'contability' || candidate === 'calendar' || candidate === 'admin'
  const mode = isKnown(normalized) ? normalized : healthCenter.default_mode
  return healthCenter.permissions[mode] ? mode : 'attention'
}
